export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    accountNumber = "",
    entityName = "",
    openingBalance = { debit: 0, credit: 0 },
    details = [],
    totalIncurred = { debit: 0, credit: 0 },
    closingBalance = { debit: 0, credit: 0 },
    totalPages = "1",
    openingDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let rowsHtml = `
    <!-- OPENING BALANCE -->
    <tr style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">- Số dư đầu kỳ</td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(openingBalance.debit)}</td>
      <td class="border text-right px-1">${fmt(openingBalance.credit)}</td>
      <td class="border"></td>
      <td class="border"></td>
    </tr>
  `;

  // Details
  details.forEach((item) => {
    rowsHtml += `
      <tr>
        <td class="border text-center">${item.bookingDate || ""}</td>
        <td class="border text-center">${item.documentNumber || ""}</td>
        <td class="border text-center">${item.documentDate || ""}</td>
        <td class="border px-1">${item.description || ""}</td>
        <td class="border text-center">${item.correspondingAccount || ""}</td>
        <td class="border text-center">${item.discountPeriod || ""}</td>
        <td class="border text-right px-1">${fmt(item.debitIncurred)}</td>
        <td class="border text-right px-1">${fmt(item.creditIncurred)}</td>
        <td class="border text-right px-1">${fmt(item.balanceDebit)}</td>
        <td class="border text-right px-1">${fmt(item.balanceCredit)}</td>
      </tr>
    `;
  });

  // Total Incurred
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">- Cộng số phát sinh</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-right px-1">${fmt(totalIncurred.debit)}</td>
      <td class="border text-right px-1">${fmt(totalIncurred.credit)}</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
    </tr>
  `;

  // Closing Balance
  rowsHtml += `
    <tr style="font-weight: bold;" bgcolor="#FAFAFA">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">- Số dư cuối kỳ</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-right px-1">${fmt(closingBalance.debit)}</td>
      <td class="border text-right px-1">${fmt(closingBalance.credit)}</td>
    </tr>
  `;

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 11px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S31-DN</div>
            <div style="font-style: italic; font-size: 10px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 16px;">SỔ CHI TIẾT THANH TOÁN VỚI NGƯỜI MUA (NGƯỜI BÁN)</h2>
        <div style="font-style: italic; font-size: 11px; margin-top: 5px;">(Dùng cho TK: 131, 331)</div>
        
        <div style="margin-top: 10px;">Tài khoản: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 20px;">${accountNumber}</span></div>
        <div style="margin-top: 5px;">Đối tượng: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 40px;">${entityName}</span></div>
        <div style="margin-top: 5px;">Loại tiền: VNĐ</div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 15px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="60">Ngày ghi sổ</th>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="40">TK đối ứng</th>
            <th class="border" rowspan="2" width="60">Thời hạn chiết khấu</th>
            <th class="border" colspan="2">Số phát sinh</th>
            <th class="border" colspan="2">Số dư</th>
          </tr>
          <tr>
            <th class="border" width="50">Số hiệu</th>
            <th class="border" width="50">Ngày</th>
            <th class="border" width="60">Nợ</th>
            <th class="border" width="60">Có</th>
            <th class="border" width="60">Nợ</th>
            <th class="border" width="60">Có</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
            <th class="border">5</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 20px;">
        <div>- Sổ này có ${totalPages} trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: ${openingDate}</div>
      </div>

      <div style="display: flex; justify-content: space-between; margin-top: 30px; text-align: center;">
        <div style="width: 30%;">
          <b>Người ghi sổ</b><br/><i>(Ký, họ tên)</i>
          <div style="margin-top: 60px;">${ledgerClerk}</div>
        </div>
        <div style="width: 30%;">
          <b>Kế toán trưởng</b><br/><i>(Ký, họ tên)</i>
          <div style="margin-top: 60px;">${chiefAccountant}</div>
        </div>
        <div style="width: 40%;">
          <i>Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</i><br/>
          <b>Người đại diện theo pháp luật</b><br/><i>(Ký, họ tên, đóng dấu)</i>
          <div style="margin-top: 60px;">${legalRepresentative}</div>
        </div>
      </div>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .px-1 { padding-left: 4px; padding-right: 4px; }
        .font-bold { font-weight: bold; }
        th, td { padding: 4px; }
      </style>
    </div>
  `;
};
